import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class CriticalStyles extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    if (this.props.amp === true) {
      return (
        <style
          amp-custom=""
          dangerouslySetInnerHTML={{ __html: `${this.props.css}` }}
        />
      );
    }

    if (!this.props.shouldRender) {
      return null;
    }

    return (
      <style
        className="critical-css"
        dangerouslySetInnerHTML={{ __html: `${this.props.css}` }}
      />
    );
  }
}

CriticalStyles.propTypes = {
  css: PropTypes.string.isRequired,
  shouldRender: PropTypes.bool.isRequired,
  amp: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    shouldRender: state.config.env !== 'development',
    css: state.config.criticalCss || '',
    amp: state.config.amp
  };
}

export default connect(mapStateToProps)(CriticalStyles);
